import { render, staticRenderFns } from "./ozoneAlarmDetail.vue?vue&type=template&id=ed53230c&scoped=true"
import script from "./ozoneAlarmDetail.vue?vue&type=script&lang=js"
export * from "./ozoneAlarmDetail.vue?vue&type=script&lang=js"
import style0 from "./ozoneAlarmDetail.vue?vue&type=style&index=0&id=ed53230c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed53230c",
  null
  
)

export default component.exports